<template>
  <div class="amenu_body">
    <div style="background-color: skyblue">
      <img src="../../../assets/logo.png" height="52" width="240" />
    </div>
    <div>
      <el-menu
        :default-active="activeIndex"
        class="el-menu-vertical-demo"
        router
        :unique-opened="true"
        @open="handleOpen"
        @close="handleClose"
        text-color="#000000A6"
        active-text-color="skyblue"
      >
        <el-submenu index="1">
          <template slot="title">
            <i class="el-icon-user-solid"></i>
            <span>系统管理</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="/loginlog">登陆日志</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <el-submenu index="2">
          <template slot="title">
            <i class="el-icon-user-solid"></i>
            <span>用户管理</span>
          </template>
          <el-menu-item-group>
            <el-menu-item index="/class">班级管理</el-menu-item>
            <el-menu-item index="/student">用户管理</el-menu-item>
            <!--<el-menu-item index="/online">在线用户</el-menu-item>-->
            <el-menu-item index="/question">理论题库</el-menu-item>
            <el-menu-item index="/testpaper">理论试卷</el-menu-item>
            <el-menu-item index="/exam">理论考试</el-menu-item>
            <el-menu-item index="/score">成绩查看</el-menu-item>
          </el-menu-item-group>
        </el-submenu>
      </el-menu>
    </div>
  </div>
</template>

<script>
export default {
  name: "Menu",
  data() {
    return {
      activeIndex: "/student",
    };
  },
  mounted() {
    this.activeIndex = this.$route.path;
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
  },
};
</script>

<style scoped>
.admin_body {
}
</style>
